import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { db } from '../../../api/fire';
import Button from '../../shared/Button';

const StyledModal = styled.div`
  position: fixed;
  background: white;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 1%;
  padding: 50px;
  border-radius: 24px;
  color: ${(props) => props.theme.primary};
  h1 {
    margin: 0;
  }
`;

const StyledButton = styled(Button)`
  padding: 0.7em 0.7em;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin: 0 10px;
`;
const StyledOptionContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 50px;
`;

const MessageModal = ({ id, closeModal, deleteMessage }) => {
  const [message, setMessage] = useState(null);
  useEffect(() => {
    db.collection('messages')
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setMessage(doc.data());
        } else {
          // doc.data() will be undefined in this case
          setMessage(null);
        }
      })
      .catch((error) => {});
    return () => {
      setMessage(null);
    };
  }, [id]);

  return (
    <StyledModal>
      {message ? (
        <>
          <h1>From: {message.fullName}</h1>
          <h3>Contact Number: {message.contactNo}</h3>
          <div>
            <h3>Message:</h3>
            <p style={{ textIndent: '90px' }}>{message.message}</p>
          </div>
          <StyledOptionContainer>
            <StyledButton
              type="button"
              onClick={() => {
                deleteMessage(id);
              }}
            >
              Delete
            </StyledButton>
            <StyledButton type="button" onClick={closeModal}>
              X
            </StyledButton>
          </StyledOptionContainer>
        </>
      ) : (
        <h1>No Message Found!</h1>
      )}
    </StyledModal>
  );
};

export default MessageModal;
